<template>
  <div class="animated revealUp">
    <!-- SEND EMAIL MODAL -->
    <b-modal
      hide-footer
      hide-header
      hide-backdrop
      no-close-on-esc
      no-close-on-backdrop
      ref="sendEmail"
      id="sendEmail"
    >
      <div class="modal-header mb-3 pt-0 pl-0 pr-0">
        <button type="button" class="close" v-on:click="hideModal('sendEmail')">
          ×
        </button>
      </div>
      <h5 class="font-weight-bold text-blue text-center">
        Are you sure you want to send this invoice to vendor?
      </h5>
      <div class="d-flex mx-auto justify-content-center">
        <button
          :disabled="disableYesButton"
          @click.prevent="onClickYes()"
          class="btn-blue"
          title="Yes"
        >
          Yes
        </button>
        <button
          @click.prevent="onClickNo()"
          class="btn btn-outline-grey btn-default"
          title="No"
        >
          No
        </button>
      </div>
    </b-modal>
    <!-- SEND EMAIL MODAL -->

    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">
        {{ $t("view") }} {{ $t("purchase") }} {{ $t("order") }}
      </div>
      <div class="d-flex">
        <button
          @click.prevent="openConfirmEmailModal()"
          class="btn-blue"
          title="Send Email"
        >
          <img src="@/assets/img/icons/email.png" height="auto" width="25" />
        </button>
        <a
          v-if="getPurchaseOrderFileName"
          :href="BASE_URL + getPurchaseOrderFileName"
          target="_blank"
          download
          class="btn-transparent"
          title="Download as PDF"
        >
          <button
            v-if="getPurchaseOrderFileName"
            class="btn-blue"
            title="Download as PDF"
          >
            <img
              src="@/assets/img/icons/pdf-icon.svg"
              height="auto"
              width="25"
            />
          </button>
        </a>
        <router-link
          v-if="purchasOrderDetails.transfer_stock_id === null"
          class="btn-blue mx-2"
          :to="
            '/fnb/edit-purchase-order?po_number=' +
              purchasOrderDetails.po_number +
              '&po_id=' +
              purchasOrderDetails.po_id
          "
          >{{ $t("edit") }}</router-link
        >
        <button
          v-if="purchasOrderDetails.po_is_approved == 'N'"
          class="btn-blue"
          title="Approve"
          @click.prevent="approvePurchaseOder()"
        >
          {{ $t("Approve") }}
        </button>
        <router-link class="btn-blue" to="/fnb/purchase-order"
          >{{ $t("purchase") }} {{ $t("order") }}
          {{ $tc("list", 2) }}</router-link
        >
      </div>
    </div>

    <div class="white-wrapper">
      <caption class="text-nowrap font-weight-bold">
        {{
          $t("purchase")
        }}
        {{
          $t("order")
        }}
      </caption>
      <table border="1" style="width:100%;margin-bottom:50px;">
        <tbody>
          <tr style="vertical-align:top;">
            <td style="width:50%;padding:5px;">
              <tr>
                <strong style="font-size:16px;">{{
                  purchasOrderDetails.v_name
                }}</strong>
              </tr>
              <tr>
                {{
                  purchasOrderDetails.v_address
                }}
              </tr>
              <!-- <tr>[City, ST ZIP]</tr> -->
              <tr>
                {{
                  $t("phone")
                }}:
                {{
                  purchasOrderDetails.v_contact
                }}
              </tr>
              <!-- <tr>Fax: (000) 000-0000</tr> -->
              <!-- <tr>Website:</tr> -->
            </td>

            <td style="padding:5px;">
              <tr>
                {{
                  $t("date")
                }}:
                {{
                  purchasOrderDetails.po_date | dateparse
                }}
              </tr>
              <tr>
                {{
                  $t("purchase")
                }}
                {{
                  $t("order")
                }}:
                {{
                  purchasOrderDetails.po_number
                }}
              </tr>
            </td>
          </tr>
        </tbody>
      </table>

      <!-- <table border="1" style="width:100%;margin-bottom:50px;">
        <thead style="background:#3876d2; color: white; text-align: center;">
          <tr>
            <th style="width:50%;padding:5px;">VENDOR</th>
            <th style="width:50%;padding:5px;">SHIP TO</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td
              style="padding:5px;"
            >Lorem ipsum dolor sit, amet consectetur adipisicing elit. Nostrum harum iure fuga velit voluptatem officiis reprehenderit voluptatibus omnis, nisi numquam facere excepturi illum, eius architecto eos quisquam quas! Quis, magnam.</td>
            <td style="padding:5px;"></td>
          </tr>
        </tbody>
      </table>-->

      <!-- <table border="1" style="width:100%;margin-bottom:50px;">
        <thead style="background:#3876d2; color: #fff; text-align: center;">
          <tr>
            <th style="padding:5px">REQUISITIONER</th>
            <th style="padding:5px">SHIP VIA</th>
            <th style="padding:5px">F.O.B.</th>
            <th style="padding:5px">SHIPPING TERMS</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>&nbsp;</td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
        </tbody>
      </table>-->

      <table border="1" style="width:100%;margin-bottom:20px;" class="po_table">
        <thead style="background:lightgrey; color: black; text-align: center;">
          <tr>
            <th style="padding:5px; text-transform: uppercase;">
              {{ $t("items") }}
            </th>
            <th style="padding:5px; text-transform: uppercase;">
              {{ $t("description") }}
            </th>
            <th style="padding:5px; text-transform: uppercase;">QTY</th>
            <th style="padding:5px; text-transform: uppercase;">UOM</th>
            <th style="padding:5px; text-transform: uppercase;">
              {{ $t("unit") }} Net {{ $tc("price", 1) }}
            </th>
            <th style="padding:5px; text-transform: uppercase;">
              {{ $t("unit") }} Gross {{ $tc("price", 1) }}
            </th>
            <th style="padding:5px; text-transform: uppercase;">NET TOTAL</th>
            <th style="padding:5px; text-transform: uppercase;">GROSS TOTAL</th>
          </tr>
        </thead>
        <tbody style="text-align:center;">
          <tr v-for="(raw, rawKey) in RawMaterialsList" :key="rawKey">
            <td class="text-left">{{ raw.rm_name }}</td>
            <td class="text-left">{{ raw.rm_description }}</td>
            <td class="text-left">{{ raw.poi_qty }}</td>
            <td class="text-left">{{ raw.uom_unit }}</td>
            <td class="text-right">{{ currFormat(raw.singlItemPrice) }}</td>
            <td class="text-right">{{ currFormat(raw.poi_gross_amount) }}</td>
            <td class="text-right">{{ currFormat(raw.poi_price) }}</td>
            <td class="text-right">{{currFormat( raw.poi_total_amount) }}</td>
          </tr>
        </tbody>
        <thead style="background:lightgrey; color: black; font-weight: bold; text-align: center;" v-if="RawMaterialsList.length > 0">
          <tr>
            <td class="text-center" colspan="6">TOTAL</td>
            <td class="text-right">{{currFormat(RawMaterialsList.reduce((acc, {poi_price}) => acc + parseFloat(poi_price), 0))}}</td>
            <td class="text-right">{{currFormat(RawMaterialsList.reduce((acc, {poi_total_amount}) => acc + parseFloat(poi_total_amount), 0))}}</td>
          </tr>
        </thead>
      </table>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import PosFnbService from "@/services/PosFnbService";
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      VendorsData: [],
      CinemaData: [],
      purchasOrderDetails: {
        cinema_id: "",
        v_id: "",
        po_grand_total: "",
        po_date: null,
        po_sub_total_amount: "",
        po_lock: false,
        po_is_active: true,
        po_number: ""
      },
      RawMaterialsList: [],
      VendorList: [],
      Cinemas: [],
      RawMaterials: [],
      Vendors: [],
      measurements: [],
      selectedCinema: "",
      selectedRawMaterial: "",
      selectedVendor: "",
      selectedQuantity: "",
      selectedUom: "",
      po_number: "",
      totalTax: 0,
      disableYesButton: false,
      currencyData: []
    };
  },
  computed: {
    ...mapGetters(["getPurchaseOrderFileName"])
  },
  beforeMount() {
    this.purchasOrderDetails.po_number = this.$route.query.po_number;
    this.purchasOrderDetails.po_id = this.$route.query.po_id;
  },
  mounted() {
    this.getCurrencyCode();
    this.getOrdersDetails();
  },
  methods: {
    hideModal: function(modal) {
      if (modal == "sendEmail") {
        this.$bvModal.hide("sendEmail");
      }
    },
    getCurrencyCode: function() {
      let payload = {
        tableName: "ms_currencies",
        curr_is_active: "Y",
        curr_id: this.secureStore.get("BRGLOPCUR")
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.currencyData = data.Records[0];
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    getOrdersDetails: function() {
      let loader = this.$loading.show();
      let payload = {
        po_id: this.purchasOrderDetails.po_id
      };
      PosFnbService.GetPurchaseOrderDetails(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.purchasOrderDetails = {
              ...this.purchasOrderDetails,
              ...data.Records[0],
              po_date: new Date(data.Records[0].po_date),
              po_lock: "Y" ? true : false,
              po_is_active: "Y" ? true : false
            };
            this.getVendorsList(this.purchasOrderDetails.v_id);
            this.getCinemasList(this.purchasOrderDetails.cinema_id);
            this.getRawMaterials(data.Records, this.purchasOrderDetails.v_id);
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError)
        .finally(async () => {
          setTimeout(() => loader.hide(), 1100);
        });
    },

    getCinemasList: function(cinema_id) {
      let payload = {
        tableName: "ms_cinemas",
        cine_is_active: "Y"
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.Cinemas.map(x => {
              if (x.cine_id == cinema_id) {
                this.selectedCinema = x.cine_name;
                this.CinemaData.push(x);
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    getunitsofmeasurements: function(uom_id, index) {
      let payload = {
        tableName: "ms_unit_of_measurement",
        uom_is_active: "Y"
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.measurements = data.Records;
            this.measurements.map(x => {
              if (x.uom_id == uom_id) {
                this.VendorList[index].uom_unit = x.uom_unit;
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    getVendorsList: function(v_id) {
      let payload = {
        tableName: "ms_vendors",
        v_is_active: "Y"
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.Vendors = data.Records;
            this.Vendors.map(x => {
              if (x.v_id == v_id) {
                this.purchasOrderDetails.v_id = v_id;
                this.selectedVendor = x.v_name;
                this.VendorsData.push(x);
              }
            });
            // this.Vendors.map((x, index) => {
            //   if (x.v_id == v_id) {
            //     this.VendorList.push({
            //       v_name: x.v_name,
            //       v_id: x.v_id,
            //       po_total_amount: po_total_amount,
            //       po_quantity: String(po_quantity),
            //       uom_unit: "",
            //       uom_id: String(uom_id),
            //       po_id: po_id
            //     });
            //   }
            // });
            // this.VendorList.map((x, index) => {
            //   this.getunitsofmeasurements(uom_id, index);
            // });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    openConfirmEmailModal: function() {
      this.$refs["sendEmail"].show();
    },
    onClickNo() {
      this.$refs["sendEmail"].hide();
    },
    approvePurchaseOder() {
      let payload = { po_id: this.purchasOrderDetails.po_id };

      PosFnbService.ApprovePurchaseOrder(payload)
        .then(response => {
          const { data } = response;

          if (data && data.status) this.$router.go(this.$router.currentRoute);
          else this.$toasted.show(data.message);
        })
        .catch(this._CatchError);
    },
    onClickYes() {
      let loader = this.$loading.show();
      this.disableYesButton = true;
      let payload = {
        po_id: this.purchasOrderDetails.po_id,
        po_number: this.purchasOrderDetails.po_number,
        pdffilename: this.getPurchaseOrderFileName
      };
      PosFnbService.sendInvoiceToVendor(payload)
        .then(response => {
          const { data } = response;
          this.$refs["sendEmail"].hide();
          this.disableYesButton = false;
          loader.hide();
          if (data.status) {
            this.$toasted.show(data.message);
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(err => {
          this.disableYesButton = false;
          loader.hide();
          this.$refs["sendEmail"].hide();
          this.$toasted.show("Something went wrong");
        });
    },
    getRawMaterials: function(Materials, vendor_id) {
      let loader = this.$loading.show();
      let payload = {
        vendor_id
      };

      PosFnbService.GetVendorRateDetails(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.RawMaterials = data.Records;
            Materials.map(x => {
              this.totalTax += x.poi_tax_amount;
              this.purchasOrderDetails.po_sub_total_amount =
                this.purchasOrderDetails.po_total_amount - this.totalTax;
              let array = data.Records.filter(({ rm_id }) => rm_id === x.rm_id);

              let poi_gross_amount = parseFloat((parseFloat(x.poi_total_amount) / parseInt(x.poi_qty))).toFixed(2)
              let poi_tax_amount_single = parseFloat((parseFloat(x.poi_tax_amount) / parseInt(x.poi_qty))).toFixed(2)

              this.RawMaterialsList.push({
                rm_name: x.rm_name,
                rm_id: x.rm_id,
                rm_description: x.rm_description,
                poi_qty: parseFloat(x.poi_qty).toFixed(2),
                po_quantity: parseFloat(x.poi_qty).toFixed(2),
                poi_price: parseFloat(x.poi_price).toFixed(2),
                poi_gross_amount: parseFloat(poi_gross_amount).toFixed(2),
                poi_total_amount: parseFloat(x.poi_total_amount).toFixed(2),
                poi_tax_percent: x.poi_tax_in_percentage,
                poi_tax_amount_single: parseFloat(poi_tax_amount_single).toFixed(2),
                uom_unit: x.uom_unit,
                uom_id: x.uom_id,
                poi_id: x.poi_id,
                poi_is_active: true,
                vendor_rate_id: x.vendor_rate_id,
                singlItemPrice: parseFloat(x.poi_price) / x.poi_qty,
                SelectedRawMaterial: array.length > 0 ? array[0] : {},
                TotalTax: this.totalTax,
                FinalSubTotal: this.purchasOrderDetails.po_sub_total_amount
              });

              // this.RawMaterialsList.map(x => {
              //   console.log('x.singleTaxPrice :', x.singleTaxPrice);
              //   this.totalTax += x.singleTaxPrice;
              // });
            });

            setTimeout(() => {
              this.$store.dispatch("FETCH_PURCHASE_ORDER_DETAILS", {
                PurchasOrderDetails: this.purchasOrderDetails,
                VendorsDetails: this.VendorsData,
                CinemasDetails: this.CinemaData,
                RawMaterialsDetails: this.RawMaterialsList,
                BasicDetails: {
                  curr_code: this.currencyData.curr_code,
                  TotalTax: this.totalTax,
                  FinalSubTotal: this.purchasOrderDetails.po_sub_total_amount
                }
              });
            }, 1000);
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError)
        .finally(async () => {
          setTimeout(() => loader.hide(), 1500);
        });
      // let payload = {
      //   tableName: "ms_raw_materials",
      //   rm_is_active: "Y"
      // };
      // MasterService.GetActiveList(payload)
      //   .then(response => {
      //     const { data } = response;
      //     if (data && data.status && data.Records.length > 0) {
      //       this.RawMaterials = data.Records;
      //       this.RawMaterialsList.push({
      //         rm_name: x.rm_name,
      //         rm_id: x.rm_id,
      //         rm_description: x.rm_description,
      //         poi_qty: String(x.poi_qty),
      //         po_quantity: String(x.poi_qty),
      //         poi_price: String(x.poi_price),
      //         uom_unit: x.uom_unit,
      //         uom_id: x.uom_id,
      //         poi_id: x.poi_id,
      //         poi_is_active: true,
      //         vendor_rate_id: x.vendor_rate_id
      //       });
      //       this.RawMaterialsList = this.RawMaterialsList.map(x => {
      //         x["singlItemPrice"] = parseFloat(x.poi_price) / x.poi_qty;
      //         return x;
      //       });
      //     } else {
      //       this.$toasted.show(data.message);
      //     }
      //   })
      //   .catch(this._CatchError); //message
    }
  }
};
</script>

<style>
.po_table tr>td {
  padding-inline: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/PurchaseOrderComponents/viewPurchaseOrder.vue